import moment from "moment";
import { EXPORT_OPTION, GSTR_2A_OPTIONS, GSTR_2B_OPTIONS, PURCHASE_FROM_COMPOSITION_DEALER_OPTION, SALES_TYPE_OPTION, SELLER_TYPE, SEZ_OPTION, SEZ_TAX_PAYMENT_OPTION, WHEATHER_ELIGIBLE } from "../../../constant/tableHeadersConstants/gst";

export const formatGstDate = (value: any) => {
    let checkFormat = new RegExp(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/)

    let dateValue = checkFormat.test(String(value))

    if (dateValue) {
        return moment(value).format("DD-MM-YYYY");
    }
    return ""

}

export function setMultiDataFunction(type: string, name: string, setMultiSelectData: any, multiSelectData: [],from?:string) {
    let findingData: any = multiSelectData?.find((item: any) => item.unique_id == name)

    if(from=="inwards"){
        if (name === "gstr2a") {
            if (findingData?.id !== name || !findingData) {
                    setMultiSelectData((prev:any)=>(type === "Yes" ? [...prev?.filter((item:any)=>item?.unique_id != name), GSTR_2A_OPTIONS[0]] : [...prev?.filter((item:any)=>item?.unique_id != name), GSTR_2A_OPTIONS[1]]))
            }
        }
        if (name === "gstr2b") {
            if (findingData?.id !== name || !findingData) {
                    setMultiSelectData((prev:any)=>(type === "Yes" ? [...prev?.filter((item:any)=>item?.unique_id != name), GSTR_2B_OPTIONS[0]] : [...prev?.filter((item:any)=>item?.unique_id != name), GSTR_2B_OPTIONS[1]]))
            }
        }
        if (name === "sellerType") {
            if (findingData?.id !== name || !findingData) {
                    setMultiSelectData((prev:any)=>(type === "B2B" ? [...prev?.filter((item:any)=>item?.unique_id != name), SELLER_TYPE[0]] : [...prev?.filter((item:any)=>item?.unique_id != name), SELLER_TYPE[1]]))
            }
        }
        if (name === "purchaseFromCompositionDealer") {
            if (findingData?.id !== name || !findingData) {
                    setMultiSelectData((prev:any)=>(type === "Yes" ? [...prev?.filter((item:any)=>item?.unique_id != name), PURCHASE_FROM_COMPOSITION_DEALER_OPTION[0]] : [...prev?.filter((item:any)=>item?.unique_id != name), PURCHASE_FROM_COMPOSITION_DEALER_OPTION[1]]))
            }
        }
        if (name === "wheatherEligible") {
            if (findingData?.id !== name || !findingData) {
                    setMultiSelectData((prev:any)=>(type === "Yes" ? [...prev?.filter((item:any)=>item?.unique_id != name), WHEATHER_ELIGIBLE[0]] : [...prev?.filter((item:any)=>item?.unique_id != name), WHEATHER_ELIGIBLE[1]]))
            }
        }
    }
    else{
        if (name === "exports") {
            if (findingData?.id !== name || !findingData) {
                    setMultiSelectData((prev:any)=>(type === "Yes" ? [...prev?.filter((item:any)=>item?.unique_id != name), EXPORT_OPTION[0]] : [...prev?.filter((item:any)=>item?.unique_id != name), EXPORT_OPTION[1]]))
            }
        }
        if (name === "sez") {
            if (findingData?.id !== name || !findingData) {
                    setMultiSelectData((prev:any)=>(type === "Yes" ? [...prev?.filter((item:any)=>item?.unique_id != name), SEZ_OPTION[0]] : [...prev?.filter((item:any)=>item?.unique_id != name), SEZ_OPTION[1]]))
            }
        }
        if (name === "sezTaxPayment") {
            if (findingData?.id !== name || !findingData) {
                    setMultiSelectData((prev:any)=>(type === "With Payment" ? [...prev?.filter((item:any)=>item?.unique_id != name), SEZ_TAX_PAYMENT_OPTION[0]] : [...prev?.filter((item:any)=>item?.unique_id != name), SEZ_TAX_PAYMENT_OPTION[1]]))
            }
        }
        if (name === "placeOfSupply") {
            if (findingData?.id !== name || !findingData) {
                    setMultiSelectData((prev:any)=>[...prev?.filter((item:any)=>item?.unique_id != name), { _id: type, unique_id: "placeOfSupply" }])
            }
        }
        if (name === "salesType") {
            if (findingData?.id !== name || !findingData) {
                    setMultiSelectData((prev:any)=>(type === "B2B" ? [...prev?.filter((item:any)=>item?.unique_id != name), SALES_TYPE_OPTION[0]] : [...prev?.filter((item:any)=>item?.unique_id != name), SALES_TYPE_OPTION[1]]))
            }
        }
    }

}